import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
import Dropdown from "../../elements/dropdown";
import Modal from "../Modal";
import BodyText from "../../elements/body-text";
import "./style.scss";

const ChangeMarketModal = ({ open, heading, body, country, button, disclaimer, link, onSubmitForm = () => {}, onCloseClicked = () => {} }) => {
  const [formDataCountry, setCountry] = useState();
  const [countrySelectCode, setCountrySelectCode] = useState(country?.selectCode);
  const [countryShowError, setCountryShowError] = useState();
  const [dropdownIsOpen, setDropdownIsOpen] = useState();
  useEffect(() => {
    setCountrySelectCode(country?.selectCode);
  }, [country]);

  const onCountryChange = option => {
    setCountry(option);
    setCountrySelectCode(option?.code);
  };
  const onSubmitFormData = () => {
    let data = {
      country: formDataCountry
    };
    if (formDataCountry && country) {
      onSubmitForm(data);
    } else {
      if (!formDataCountry) {
        setCountryShowError(true);
      }
    }
  };
  return (
    <Modal className="change-market-modal" showModal={open} onCloseClicked={onCloseClicked} disabled={dropdownIsOpen}>
      <React.Fragment>
        <Heading {...heading} className="change-market-modal-heading" typographyClass="type-h1" />
        <BodyText html={body} className="change-market-modal-body" />

        <Dropdown
          {...{
            ...country,
            selectCode: countrySelectCode,
            optionsMaxHeightVal: 270,
            onChange: value => {
              onCountryChange(value);
              setTimeout(function() {
                setDropdownIsOpen(false);
              }, 1000);
            },
            className: "change-market-modal-dropdown",
            showError: countryShowError,
            onFocus: () => {
              setCountryShowError(false);
              setDropdownIsOpen(true);
            }
          }}
        />

        <div className="change-market-modal-button">
          <PrimaryButton
            {...{
              ...button,
              callback: event => onSubmitFormData(event)
            }}
          />
          <SimpleLink {...{ ...link, callback: onCloseClicked }} />
        </div>

        {disclaimer && disclaimer.body !== "" && (
          <div className="change-market-modal-disclaimer">
            <BodyText html={disclaimer.body} className="disclaimer" />
          </div>
        )}
      </React.Fragment>
    </Modal>
  );
};

export default ChangeMarketModal;

ChangeMarketModal.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.string,
  button: PropTypes.object,
  country: PropTypes.object,
  link: PropTypes.object,
  disclaimer: PropTypes.object,
  onSubmitForm: PropTypes.func
};
ChangeMarketModal.defaultProps = {
  onSubmitForm: () => {},
  disclaimer: { body: "" }
};
